module.exports = __webpack_public_path__ + "img/2_list2.b1b22301.png";